<template>
  <div class="col-md-8 offset-md-2 mt-5 formBlock">
    <h2 class="formTitle mt-1 mb-5">We'll customize a plan specifically for your needs.</h2>
    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>
    <CCol sm="12">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.fullName')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.fullName.$model"
        :isValid="!$v.contactForm.fullName.$anyError"
        :invalidFeedback="$t('faqs.contactUs.form.validation.requiredFieldText')"
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.email')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.emailAddress.$model"
        :isValid="!$v.contactForm.emailAddress.$anyError"
        :invalidFeedback="
          !$v.contactForm.emailAddress.required
            ? $t('faqs.contactUs.form.validation.requiredFieldText')
            : !$v.contactForm.emailAddress.email
            ? $t('faqs.contactUs.form.validation.emailField')
            : $t('faqs.contactUs.form.validation.requiredFieldText')
        "
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.companyName')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.companyName.$model"
        :isValid="!$v.contactForm.companyName.$anyError"
        :invalidFeedback="$t('faqs.contactUs.form.validation.requiredFieldText')"
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        :label="$t('manageplan.contactForm.form.phoneNumber')"
        addLabelClasses="mt-1 required"
        :value.sync="$v.contactForm.phoneNumber.$model"
        :isValid="!$v.contactForm.phoneNumber.$anyError"
        :invalidFeedback="
          !$v.contactForm.phoneNumber.required
            ? $t('faqs.contactUs.form.validation.requiredFieldText')
            : !$v.contactForm.phoneNumber.numeric
            ? $t('faqs.contactUs.form.validation.numericFieldText')
            : $t('faqs.contactUs.form.validation.requiredFieldText')
        "
      />
    </CCol>
    <CCol sm="12" class="mt-3">
      <CInput
        class="mb-0 inputContactForm"
        :maxlength="30"
        @keyup="updateValueNumberContacts"
        :min="0"
        :label="$t('manageplan.contactForm.form.numberOfContacts')"
        addLabelClasses="mt-1 required"
        v-model="contactForm.numberOfContacts"
        type="number"
      />
    </CCol>
    <CRow class="canWeContact">
      <CCol sm="12" class="">
        <span class="canCallAboutServices">{{ $t('manageplan.contactForm.form.canCallAboutServices') }}</span>
      </CCol>
      <CCol sm="2" class="mt-3">
        <CInputRadio
          :label="$t('manageplan.contactForm.form.yes')"
          type="radio"
          :value="contactForm.yes"
          name="target"
          :checked="contactForm.canCallAboutServices"
          @change="updateCanCall(contactForm.yes)"
        />
      </CCol>
      <CCol sm="2" class="mt-3">
        <CInputRadio
          :label="$t('manageplan.contactForm.form.no')"
          type="radio"
          :value="contactForm.no"
          name="target"
          class=""
          :checked="!contactForm.canCallAboutServices"
          @change="updateCanCall(contactForm.no)"
        />
      </CCol>
    </CRow>
    <CCol sm="12" class="mt-3">
      <CButton color="primary" :disabled="loading" class="w-100" @click="sendContactForm()">
        {{ $t('manageplan.contactForm.form.btn') }}
        <CSpinner v-if="isLoadingSend" color="primary" class="ml-3" style="width: 1.5rem; height: 1.5rem" />
      </CButton>
    </CCol>
  </div>
</template>

<script>
import services from '@/services.js'
import { getErrorMessage } from '@/utils/errorHandling.js'
import MenssageAlert from '@/components/MenssageAlert'
import { validationMixin } from 'vuelidate'
import { required, email, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'ContactForm',
  components: { MenssageAlert },
  data() {
    return {
      isLoadingSend: false,
      loading: false,
      contactForm: {
        fullName: undefined,
        emailAddress: undefined,
        companyName: undefined,
        phoneNumber: undefined,
        numberOfContacts: undefined,
        canCallAboutServices: true,
        yes: true,
        no: false,
      },
      messages: [],
    }
  },
  mixins: [validationMixin],
  validations: {
    contactForm: {
      fullName: {
        required,
      },
      emailAddress: {
        required,
        email,
      },
      companyName: {
        required,
      },
      phoneNumber: {
        required,
        numeric,
      },
      subject: {
        required,
      },
    },
  },
  computed: {
    hasContactInfo() {
      return (
        this.contactForm.fullName &&
        this.contactForm.email &&
        this.contactForm.companyName &&
        this.contactForm.phoneNumber &&
        this.contactForm.numberOfContacts
      )
    },
  },
  methods: {
    updateCanCall(value) {
      this.contactForm.canCallAboutServices = value
    },
    updateValueNumberContacts(t) {
      this.contactForm.numberOfContacts = parseInt(this.contactForm.numberOfContacts)
      if (this.contactForm.numberOfContacts < 0) {
        this.contactForm.numberOfContacts = 0
      }
    },
    clearContactFormData() {
      this.contactForm = {
        fullName: undefined,
        email: undefined,
        companyName: undefined,
        phoneNumber: undefined,
        numberOfContacts: undefined,
        canCallAboutServices: true,
        yes: true,
        no: false,
      }
    },
    async sendContactForm() {
      try {
        this.$v.$touch()

        if (this.$v.$anyError) return

        this.isLoadingSend = true

        this.loading = true

        const data = {
          fullName: this.contactForm.fullName,
          email: this.contactForm.email,
          companyName: this.contactForm.companyName,
          phoneNumber: this.contactForm.phoneNumber,
          numberOfContacts: this.contactForm.numberOfContacts,
          canCallAboutServices: this.contactForm.canCallAboutServices,
        }

        const organizationId = this.$route.params.organizationId
        await services.postPlansInfo(organizationId, data)

        this.messages = [
          {
            status: 'success',
            text: this.$t('faq.contacat.success.messaage'),
          },
        ]

        this.clearContactFormData()

        setTimeout(() => {
          this.$emit('sentSuccessfully')
        }, 2000)
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
      } finally {
        this.isLoadingSend = false
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.formBlock {
  background-color: #fff;
  padding: 50px 35px;
}

.inputContactForm input {
  border: 1px solid #dee2e6 !important;
}

.formTitle {
  font-size: 24px;
  color: #343a40;
  text-align: center;
}

.canWeContact {
  padding: 20px;
}

.canCallAboutServices {
  font-weight: 600;
  font-size: 1rem;
}

.btnSend {
  background-color: #403266;
  border-radius: 5px;
  color: #fff;
  width: 100%;
  height: 50px;
  border: 1px solid #403266;
}
</style>
